<template>
    <div>
        <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">
            签约项目管理-{{ form.id != null && form.id != '' ? '修改' : '新增' }}
        </div>
        <el-button
            style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
            @click="Return">返回</el-button>
        <div
            style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; margin-top: 9px; padding-top: 30px; overflow-x: hidden">

            <div style="border-left: 3px #006E4B solid; height: 20px; width: 100%; margin-left: 30px;">
                <span style="margin-left: 10px; font-size: 20px; line-height: 20px; font-weight: bold;">项目基础信息</span>
            </div>
            <hr style="margin-left: 30px; margin-right: 30px; margin-top: 20px; margin-bottom: 30px;" />

            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="190px" class="demo-ruleForm">

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="组织架构" prop="organize_ids" v-show="form.id != null && form.id != ''">
                            <div
                                style="border:1px solid #DCDFE6; width:75%;border-radius:5px;padding-left:10px;padding-right:10px">
                                {{ $globals.group_name + "/" + form.organize_name }}
                            </div>
                        </el-form-item>
                        <el-form-item label="组织架构" prop="organize_ids" v-show="form.id === null || form.id === ''">
                            <el-cascader v-model="form.organize_temporary_ids" @change="changeCascader"
                                style="width:80%;" collapse-tags :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="城市" prop="city">
                            <el-select v-model="form.city" style="width:80%" placeholder="请选择" clearable>
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="甲方名头" prop="party_title">
                            <el-input v-model="form.party_title" style="width: 80%;" placeholder="请输入甲方名头">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="乙方名头" prop="spare6">
                            <el-select v-model="form.spare6" style="width:80%" placeholder="请选择" clearable>
                                <el-option v-for="item in $parent.partnerList" :key="item.id"
                                    :label="item.partner_abbreviation" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="合同编码" prop="contract_code">
                            <el-input v-model="form.contract_code" style="width: 80%;" placeholder="请输入合同编码">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同名称" prop="contract_name">
                            <el-input v-model="form.contract_name" style="width: 80%;" placeholder="请输入合同名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="业务系列" prop="series_id">
                            <el-select v-model="form.series_id" style="width:80%" placeholder="请选择" clearable>
                                <el-option v-for="item in seriesList" :key="item.id" :label="item.data" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="业务板块" prop="andInnovation_id">
                            <el-select v-model="form.andInnovation_id" style="width:80%" placeholder="请选择" clearable>
                                <el-option v-for="item in andInnovationList" :key="item.id" :label="item.data" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="合同开始时间" prop="contract_start_date">
                            <el-date-picker v-model="form.contract_start_date" type="date" style="width: 80%;"
                                placeholder="请选择" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同结束时间" prop="contract_end_date">
                            <el-date-picker v-model="form.contract_end_date" type="date" style="width: 80%;"
                                placeholder="请选择" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="合同核算单位" prop="contract_unit">
                            <el-select v-model="form.contract_unit" style="width:80%" placeholder="请选择" clearable
                                @change="ContractUnitOperate">
                                <el-option v-for="item in contractUnitList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务费核算标准" prop="service_charge_standard">
                            <el-select v-model="form.service_charge_standard" style="width:80%" placeholder="请选择"
                                clearable>
                                <el-option v-for="item in serviceChargeStandardList" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="项目名称" prop="project_name">
                            <el-input v-model="form.project_name" style="width: 80%;" placeholder="请输入项目名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="项目地址" prop="project_site">
                            <el-input v-model="form.project_site" style="width: 80%;" placeholder="请输入项目地址">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item :label="contract_headcount_label" prop="contract_headcount">
                            <el-input type="number" v-model="form.contract_headcount" style="width: 80%;"
                                :placeholder="contract_headcount_placeholder">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="contract_min_count_label" prop="contract_min_count">
                            <el-input type="number" v-model="form.contract_min_count" style="width: 80%;"
                                :placeholder="contract_min_count_placeholder">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="合同要求每日每人最多工时" prop="contract_max_labor_hour">
                            <el-input type="number" v-model="form.contract_max_labor_hour" style="width: 80%;"
                                placeholder="请输入合同要求每日每人最多工时">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同要求每日最少工时" prop="contract_min_day_labor_hour">
                            <el-input type="number" v-model="form.contract_min_day_labor_hour" style="width: 80%;"
                                placeholder="请输入合同要求每日最少工时">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="合同要求每月最少工时" prop="contract_min_month_labor_hour">
                            <el-input type="number" v-model="form.contract_min_month_labor_hour" style="width: 80%;"
                                placeholder="请输入合同要求每月最少工时">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否使用客户要求" prop="is_client_require">
                            <el-radio v-model="form.is_client_require" :label="1">是</el-radio>
                            <el-radio v-model="form.is_client_require" :label="0">否</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="月度合同金额" prop="monthly_contract_amount">
                            <el-input v-model="form.monthly_contract_amount" style="width: 80%;"
                                placeholder="请输入月度合同金额">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="代发公司" prop="agency_company">
                            <el-select v-model="form.agency_company" style="width:80%" placeholder="请选择" clearable>
                                <el-option v-for="item in causeList" :key="item.id" :label="item.data" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="撤场日期" prop="withdrawal_date">
                            <el-date-picker v-model="form.withdrawal_date" type="date" style="width: 80%;"
                                placeholder="请选择" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="进场日期" prop="mobilization_date">
                            <el-date-picker v-model="form.mobilization_date" type="date" style="width: 80%;"
                                placeholder="请选择" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="结算方式" prop="settlement_method">
                            <el-select v-model="form.settlement_method" style="width:80%" placeholder="请选择" clearable
                                @change="ContractUnitOperate">
                                <el-option v-for="item in methodList" :key="item.label" :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="预算定额人数" prop="budget_quota_number">
                            <el-input type="number" v-model="form.budget_quota_number" style="width: 80%;"
                                placeholder="请输入预算定额人数">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="年度合同收入" prop="annual_contract_revenue">
                            <el-input v-model="form.annual_contract_revenue" style="width: 80%;"
                                placeholder="请输入年度合同收入">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="物料定额" prop="material_quota">
                            <el-input v-model="form.material_quota" style="width: 80%;" placeholder="请输入物料定额">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="工资定额" prop="wage_quota">
                            <el-input v-model="form.wage_quota" style="width: 80%;"
                                placeholder="请输入工资定额">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">

                    </el-col>
                </el-row>

                <el-row style="padding: 0 10%;">
                    <el-col :span="12">
                        <el-form-item label="打卡参考地点照片">
                            <el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
                                :show-file-list="false" :on-success="handleBankPhotoSuccess">
                                <img v-if="form.clock_in_reference_location" :src="form.clock_in_reference_location"
                                    class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                    </el-col>

                </el-row>
                <el-form-item v-if="form.id != null && form.id != ''" label="合同单价:" style="padding: 0 10%;">
                    <el-row style="margin-bottom: 10px;" v-for="(item, index) in form.contractCount" :key="index">
                        <el-col :span="8">
                            <el-form-item>
                                <el-input v-model="form.contractList[index].contract_price" style="width: 98%;">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <img src="../../../assets/icon/添加.png" width="20px" @click="shiftAdd(index)"
                                v-show="(index + 1) == form.contractCount.length" />
                            <img src="../../../assets/icon/减少.png" width="20px" @click="shiftRemove(index)"
                                v-show="index != 0" />
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label-width="0" style="text-align: center;">
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;"
                        v-show="form.id == null || form.id == ''" @click="Add">提交</el-button>
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;"
                        v-show="form.id != null && form.id != ''" @click="Update">修改</el-button>
                </el-form-item>
            </el-form>
        </div>


        <!-- <el-dialog title="设置班次" :visible.sync="dialogVisibles" width="50%" :before-close="handleClose">
            <div>
                <el-row style="height: 506px;overflow-y:scroll">
                    <el-form :model="projectPost" ref="ruleForm" label-width="160px" class="demo-ruleForm"
                        style="margin-top: 30px;">
                        <el-form-item label="合同单价:">
                            <el-row style="margin-bottom: 20px;" v-for="(item, index) in form.contractCount"
                                :key="index">
                                <el-form :model="form.contractList[index]">
                                    <el-col :span="4">
                                        <el-form-item prop="contract_price">
                                            <el-input v-model="form.contractList[index].contract_price"
                                                style="width: 80%;">
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="3">
                                        <img src="../../../assets/icon/添加.png" width="20px" @click="shiftAdd(index)"
                                            v-show="(index + 1) == form.contractCount.length" />
                                        <img src="../../../assets/icon/减少.png" width="20px" @click="shiftRemove(index)"
                                            v-show="index != 0" />
                                    </el-col>
                                </el-form>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibles = false">取 消</el-button>
                <el-button type="primary" style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;"
                    @click="UpdateSure">确定
                </el-button>
            </div>
        </el-dialog> -->

    </div>
</template>

<script>
export default {

    props: ["ruleForm", "organizeList"],
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        var contractHeadcount = (rule, value, callback) => {
            if (!value) {
                if (this.form.contract_unit == "2") {
                    return callback(new Error('请输入合同要求总工时数！'));
                } else if (this.form.contract_unit == "1") {
                    return callback(new Error('请输入合同要求总岗数！'));
                } else {
                    return callback(new Error('请输入合同要求总人数！'));
                }
            } else {
                callback();
            }
        };
        var contractMinCount = (rule, value, callback) => {
            if (!value) {
                if (this.form.contract_unit == "2") {
                    return callback(new Error('请输入合同要求每日最少工时数！'));
                } else if (this.form.contract_unit == "1") {
                    return callback(new Error('请输入合同要求每日最少岗数！'));
                } else {
                    return callback(new Error('请输入合同要求每日最少人数！'));
                }
            } else {
                callback();
            }
        };
        return {
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: false,
            },
            //代发公司
            causeList: [],
            dialogVisibles: false,
            seriesList: [],//业务系列
            andInnovationList: [],//业务板块
            //表单数据
            form: {
                id: "",
                company_id: "",
                company_name: "",
                organize_name: "",
                organize_id: "",
                organize_ids: '',
                organize_temporary_ids: [],
                project_id: '',
                modular_name: "",
                city: "",
                contract_code: "",
                contract_unit_title: "",
                service_charge_standard_title: "",
                partner_name: "",
                spare6: "",
                party_title: "",
                contract_name: "",
                contract_start_date: "",
                contract_end_date: "",
                contract_unit: "",
                service_charge_standard: "",
                project_name: "",
                project_site: "",
                contract_headcount: "",
                contract_min_count: "",
                contract_max_labor_hour: "",
                contract_min_day_labor_hour: "",
                contract_min_month_labor_hour: "",
                is_client_require: "0",
                is_client_require_title: "",
                projectPostList: [],
                monthly_contract_amount: '',
                agency_company: '',
                clock_in_reference_location: '',
                contractList: [{
                    contract_price: "",
                }],
                contractCount: [1],
                withdrawal_date: '',
                mobilization_date: '',
                settlement_method: '',
                budget_quota_number: '',
                annual_contract_revenue: '',
                material_quota: '',
                wage_quota:'',
                series_id:'',
                andInnovation_id:'',
            },

            //表单验证
            rules: {

                organize_ids: [{
                    required: true,
                    message: '请选择组织架构！',
                    trigger: 'blur'
                }],
                city: [{
                    required: true,
                    message: '请选择城市！',
                    trigger: 'blur'
                }],
                // contract_code: [{
                //     required: true,
                //     message: '请输入合同编码！',
                //     trigger: 'blur'
                // }],
                // party_title: [{
                //     required: true,
                //     message: '请选择甲方名头！',
                //     trigger: 'blur'
                // }],
                // contract_name: [{
                //     required: true,
                //     message: '请输入合同名称！',
                //     trigger: 'blur'
                // }],
                // contract_start_date: [{
                //     required: true,
                //     message: '请选择合同开始时间！',
                //     trigger: 'blur'
                // }],
                // contract_end_date: [{
                //     required: true,
                //     message: '请选择合同结束时间！',
                //     trigger: 'blur'
                // }],
                // contract_unit: [{
                //     required: true,
                //     message: '请选择合同核算单位！',
                //     trigger: 'blur'
                // }],
                // service_charge_standard: [{
                //     required: true,
                //     message: '请选择服务费核算标准！',
                //     trigger: 'blur'
                // }],
                project_name: [{
                    required: true,
                    message: '请输入项目名称！',
                    trigger: 'blur'
                }],
                project_site: [{
                    required: true,
                    message: '请输入项目地址！',
                    trigger: 'blur'
                }],
                // contract_headcount: [{
                //     required: true,
                //     validator: contractHeadcount,
                //     trigger: 'blur'
                // }],
                // contract_min_month_labor_hour: [{
                //     required: true,
                //     message: '请输入合同要求每月最少工时！',
                //     trigger: 'blur'
                // }],
                // contract_min_count: [{
                //     required: true,
                //     validator: contractMinCount,
                //     trigger: 'blur'
                // }],
                // contract_max_labor_hour: [{
                //     required: true,
                //     message: '请输入合同要求每日每人最多工时！',
                //     trigger: 'blur'
                // }],
                // contract_min_day_labor_hour: [{
                //     required: true,
                //     message: '请输入合同要求每日最少工时！',
                //     trigger: 'blur'
                // }],
                // is_client_require: [{
                //     required: true,
                //     message: '请选择是否使用客户要求！',
                //     trigger: 'blur'
                // }],
                // spare6: [{
                //     required: true,
                //     message: '请选择乙方名头！',
                //     trigger: 'blur'
                // }],
            },

            //板块
            plate_placeholder: "请先选择组织架构",
            plateList: [],
            //合同核算单位
            contractUnitList: [{
                value: 3,
                label: "人"
            },
            {
                value: 1,
                label: "岗"
            },
            {
                value: 2,
                label: "工时"
            },
            ],
            //结算方式
            methodList: [{
                label: "当月"
            },
            {
                label: "季度"
            },
            {
                label: "半年"
            },
            {
                label: "年付"
            },
            {
                label: "押一付一"
            },
            {
                label: "押三付一"
            },
            {
                label: "押二付一"
            }],
            //服务费核算标准
            serviceChargeStandardList: [{
                value: 1,
                label: "日在岗数",
                is: "1"
            },
            {
                value: 2,
                label: "月度综合在岗数",
                is: "1"
            },
            {
                value: 3,
                label: "日工时数",
                is: "2"
            },
            {
                value: 4,
                label: "月度综合工时数",
                is: "2"
            },
            {
                value: 5,
                label: "日在岗人数",
                is: "3"
            },
            {
                value: 6,
                label: "月度综合在岗人数",
                is: "3"
            },
            ],

            //标签
            contract_headcount_label: "合同要求总人数",
            contract_headcount_placeholder: "请输入合同要求总人数",
            contract_min_count_label: "合同要求每日最少人数",
            contract_min_count_placeholder: "请输入合同要求每日最少人数",


        };
    },
    methods: {
        shiftAdd(e) {
            this.form.contractCount.push(1);
            this.form.contractList.push({
                contract_price: "",
            });
        },

        shiftRemove(e) {
            this.form.contractCount.splice(e, 1);
            this.form.contractList.splice(e, 1);
        },
        //修改标签
        ContractUnitOperate() {
            switch (this.form.contract_unit) {
                case 3:
                    this.contract_headcount_label = "合同要求总人数";
                    this.contract_min_count_label = "合同要求每日最少人数";
                    this.contract_headcount_placeholder = "请输入合同要求总人数";
                    this.contract_min_count_placeholder = "请输入合同要求每日最少人数";
                    break;
                case 1:
                    this.contract_headcount_label = "合同要求总岗数";
                    this.contract_min_count_label = "合同要求每日最少岗数";
                    this.contract_headcount_placeholder = "请输入合同要求总岗数";
                    this.contract_min_count_placeholder = "请输入合同要求每日最少岗数";
                    break;
                case 2:
                    this.contract_headcount_label = "合同要求总工时数";
                    this.contract_min_count_label = "合同要求每日最少工时数";
                    this.contract_headcount_placeholder = "请输入合同要求总工时数";
                    this.contract_min_count_placeholder = "请输入合同要求每日最少工时数";
                    break;
            }
        },
        //本人照片上传
        handleBankPhotoSuccess(res, file) {
            this.form.clock_in_reference_location = res.data.fileUrl;
        },
        //选择板块
        async Plate(e) {
            if (e != undefined && e != null && e != '') {
                this.plate_placeholder = "请先选择分公司";
                this.plateList = [];
            } else {
                this.form.organize_id = "";
                this.plate_placeholder = "请先选择分公司";
                this.plateList = [];
            }

            if (this.form.company_id != null && this.form.company_id != '') {
                var plateList = await this.$globals.AxiosPost("organize/selectOrganizesing", {
                    organize_id: this.form.company_id
                });

                this.plate_placeholder = "请选择";
                this.plateList = plateList.data;
            }
        },
        //添加操作
        Add() {
            this.$refs["ruleForm"].validate(async (valid) => {
                if (valid) {
                    var url = "project/add";
                    var record = {
                        organize_id: this.form.organize_id,
                        organize_ids: this.form.organize_ids,
                        city: this.form.city,
                        contract_code: this.form.contract_code,
                        party_title: this.form.party_title,
                        contract_name: this.form.contract_name,
                        contract_start_date: this.form.contract_start_date,
                        contract_end_date: this.form.contract_end_date,
                        contract_unit: this.form.contract_unit,
                        service_charge_standard: this.form.service_charge_standard,
                        project_name: this.form.project_name,
                        project_site: this.form.project_site,
                        contract_headcount: this.form.contract_headcount,
                        contract_min_count: this.form.contract_min_count,
                        contract_max_labor_hour: this.form.contract_max_labor_hour,
                        contract_min_day_labor_hour: this.form.contract_min_day_labor_hour,
                        contract_min_month_labor_hour: this.form.contract_min_month_labor_hour,
                        is_client_require: this.form.is_client_require,
                        spare6: this.form.spare6,
                        monthly_contract_amount: this.form.monthly_contract_amount,
                        agency_company: this.form.agency_company,
                        clock_in_reference_location: this.form.clock_in_reference_location,
                        withdrawal_date: this.form.withdrawal_date,
                        mobilization_date: this.form.mobilization_date,
                        settlement_method: this.form.settlement_method,
                        budget_quota_number: this.form.budget_quota_number,
                        annual_contract_revenue: this.form.annual_contract_revenue,
                        material_quota: this.form.material_quota,
                        wage_quota: this.form.wage_quota,
                        series_id: this.form.series_id,
                        andInnovation_id: this.form.andInnovation_id,
                    };
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data == '-2000') {
                        this.$message.error("服务器未响应！请稍后重试");
                    } else {
                        var code = data.code;
                        var data = data.data;
                        if (code == '200') {
                            this.$message.success(data.msg);
                            this.Return();
                            this.$parent.Details(data.id);
                        } else {
                            this.$message.warning(data);
                        }
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        async UpdateSure() {

        },

        //修改操作
        Update() {
            this.$refs["ruleForm"].validate(async (valid) => {
                if (valid) {
                    var url = "project/modify";
                    var record = {
                        id: this.form.id,
                        organize_id: this.form.organize_id,
                        organize_ids: this.form.organize_ids,
                        city: this.form.city,
                        contract_code: this.form.contract_code,
                        party_title: this.form.party_title,
                        contract_name: this.form.contract_name,
                        contract_start_date: this.form.contract_start_date,
                        contract_end_date: this.form.contract_end_date,
                        contract_unit: this.form.contract_unit,
                        service_charge_standard: this.form.service_charge_standard,
                        project_name: this.form.project_name,
                        project_site: this.form.project_site,
                        contract_headcount: this.form.contract_headcount,
                        contract_min_count: this.form.contract_min_count,
                        contract_max_labor_hour: this.form.contract_max_labor_hour,
                        contract_min_day_labor_hour: this.form.contract_min_day_labor_hour,
                        contract_min_month_labor_hour: this.form.contract_min_month_labor_hour,
                        is_client_require: this.form.is_client_require,
                        spare6: this.form.spare6,
                        monthly_contract_amount: this.form.monthly_contract_amount,
                        agency_company: this.form.agency_company,
                        clock_in_reference_location: this.form.clock_in_reference_location,
                        projectContractList: this.form.contractList,
                        withdrawal_date: this.form.withdrawal_date,
                        mobilization_date: this.form.mobilization_date,
                        settlement_method: this.form.settlement_method,
                        budget_quota_number: this.form.budget_quota_number,
                        annual_contract_revenue: this.form.annual_contract_revenue,
                        material_quota: this.form.material_quota,
                        wage_quota: this.form.wage_quota,
                        series_id: this.form.series_id,
                        andInnovation_id: this.form.andInnovation_id,
                    };
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data == '-2000') {
                        this.$message.error("服务器未响应！请稍后重试");
                    } else {
                        var code = data.code;
                        var data = data.data;
                        if (code == '200') {
                            this.$message.success(data);
                            this.dialogVisibles = false;
                            this.Return();
                        } else {
                            this.$message.warning(data);
                        }
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        changeCascader() {
            this.form.organize_ids = '';
            this.form.organize_temporary_ids.forEach(item => {
                this.form.organize_ids += item + ','
            })
            this.form.organize_id = this.form.organize_temporary_ids[this
                .form.organize_temporary_ids.length - 1];
        },
        //返回
        Return() {
            this.$parent.Return('add');
        }
    },
    async created() {
        this.form = this.$parent.form;
        // 代发公司
        var causeList = await this.$globals.AxiosPost('dictionaries/selectFind', {
            data_grouping: 'agency_company'
        });
        this.causeList = causeList.data;

        // 业务系列
        var seriesList = await this.$globals.AxiosPost('dictionaries/selectFind', {
            data_grouping: 'business_series'
        });
        this.seriesList = seriesList.data;

        // 业务板块
        var andInnovationList = await this.$globals.AxiosPost('dictionaries/selectFind', {
            data_grouping: 'business_sector'
        });
        this.andInnovationList = andInnovationList.data;

    }
}
</script>

<style scoped="scoped">
>>>.el-radio__input.is-checked .el-radio__inner {
    background-color: #006E4B;
    border-color: #006E4B;
}

>>>.el-radio__input.is-checked+.el-radio__label {
    color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// QyxmGl_add.vue?6034185c